import { cn } from '@/lib/utils';
import { CSSProperties } from 'react';

interface RichTextDisplayProps {
  content: string;
  className?: string;
  style?: CSSProperties;
  forceLeftAlign?: boolean;
}

/**
 * Component for displaying rich text content created by RichTextEditor
 * Applies consistent styling to the HTML content
 */
export const RichTextDisplay = ({
  content,
  className = '',
  style,
  forceLeftAlign = false,
}: RichTextDisplayProps) => {
  return (
    <div
      className={cn(
        'rich-text-content',
        forceLeftAlign && '[&_*]:!text-start',
        className,
      )}
      style={style}
      dangerouslySetInnerHTML={{ __html: content || '' }}
    />
  );
};
